import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>

                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Standing by or taking responsibility in an emergency is not a
                                                situation that most of us have to face
                                                very often. However, there are everyday instances at work when
                                                there is the chance to take
                                                responsibility. This tool is all about <span
                                                    className="brown brownbold"> how to take responsibility</span> and
                                                will help you to take ownership
                                                of situations and understand what responsibility entails.</p>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>TAKING RESPONSIBILITY
                                            </div>
                                            <p>Imagine you’re in the office, about to print off those reports
                                                but the copier’s out of toner. Why
                                                didn’t whoever used it last replace it? The stationery cupboard
                                                is chaotic and you need to step
                                                over things and look behind other things to find what you need.
                                                Why do people leave such a
                                                mess? Why isn’t someone responsible for keeping it tidy – and
                                                checking the copiers, too, come
                                                to think of it? And, why don’t you?</p>
                                            <p>It’s the kind of mildly irritating situation we all recognise,
                                                and undoubtedly contribute to. What
                                                about, however, a situation similarly caused, but cranked up to
                                                a critical level – resulting in major
                                                catastrophe or even loss of life? What about the whole concept
                                                of ‘collective responsibility’ and
                                                what history reveals about that?</p>
                                            <p>It’s complex. However, for your purposes, we offer some general
                                                principles to help you to be more
                                                responsible and thereby more productive, efficient and
                                                motivated. This diagram’s a good start:</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/responsibilty_img.png')}
                                                    alt=""/>
                                            </div>

                                            <p>The ‘Taking Responsibility’ model presents us with five potential
                                                blockages to taking responsibility.
                                                Here we will look at the evidence for how they can affect you
                                                and others, and show you how to
                                                tackle the challenges they present.</p>
                                            <div className="border_subtitle">Fear of failure</div>
                                            <p>Psychologists would argue that we’re conditioned from childhood
                                                to seek approval from others.
                                                This can result in many of us avoiding opportunities to try
                                                something new in case we might get it
                                                ‘wrong’. In the workplace we sidestep relatively trivial actions
                                                we wouldn’t think twice about at
                                                home or elsewhere, rather than risk criticism or failure.
                                                However, there are ways of overcoming
                                                fears which stop us from applying ourselves when we can’t
                                                guarantee success. We’ll also
                                                demonstrate the benefits we can gain from our efforts, whatever
                                                the outcome. We’ll explain these
                                                in the following sections.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}